// Check if the screen width is greater than a certain threshold
function isDesktop() {
    return window.innerWidth > 768; 
}

// Initialize desktop-specific functionality
function initializeDesktop() {
    const productInformation = document.querySelector('.go-pdp-meta-wrapper .product-single__meta');
    const productGridContainer = document.querySelector('.go-product-wrapper.grid');

    if (!productInformation || !productGridContainer) {
        return; // Exit if elements are not found
    }

    let isScrollingPaused = false;

    // Function to handle wheel events
    const handleWheel = (event) => { 
        if (!isScrollingPaused) {
            return; // Allow normal scrolling if not paused
        }
    
        const deltaY = event.deltaY; // Get the vertical scroll amount
        const currentScrollTop = productInformation.scrollTop;
        const newScrollTop = currentScrollTop + deltaY;
     
    
        // Check if at the top
        if (currentScrollTop === 0 && deltaY < 0) { 
            return; // Allow default scrolling behavior
        }
    
        // Check if at the bottom (fix: added `-1` to account for rounding errors)
        if (currentScrollTop + productInformation.offsetHeight >= productInformation.scrollHeight - 1 && deltaY > 0) { 
            return; // Allow default scrolling behavior
        }
    
        // Apply the new scroll position to the text container
        productInformation.scrollTop = newScrollTop; 
        event.preventDefault(); // Prevent default scrolling behavior
    };
    

    // Set up mouseenter and mouseleave events to pause/resume scrolling
    productGridContainer.addEventListener('mouseenter', () => {
        isScrollingPaused = true; // Pause scrolling
    });

    productGridContainer.addEventListener('mouseleave', () => {
        isScrollingPaused = false; // Resume scrolling
    });

    // Synchronize scroll event between image container and product description container
    productGridContainer.addEventListener('wheel', handleWheel);
}

// Function to handle the screen resize event
function handleResize() {
    if (isDesktop()) {
        initializeDesktop();
    }
}

// Call the initializeDesktop function on page load if the screen is desktop
document.addEventListener('DOMContentLoaded', () => {
    if (isDesktop()) {
        initializeDesktop();
    }
});

// Call the handleResize function when the screen is resized
window.addEventListener('resize', handleResize);
